'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import { Breadcrumb } from '@sola/ark-skippy/molecules/breadcrumb/breadcrumb.tsx';
import { VolunteerTourTemplate } from '@sola/ark-skippy/templates/volunteer/volunteer-tour-template.tsx';
import { getInvolvedUrlBase } from '@sola/contentful-model/lib/routes.ts';
import type { LOCALES_CODES } from '@sola/contentful-model/lib/types.ts';
import { getVolunteerRolesPath, getVolunteerTourPath } from '@sola/contentful-model/lib/volunteer.ts';
import type { VolunteerLocationItemDto } from '@sola/skippy-search-sdk/lib/schema.ts';
import { slashes } from '@sola/utils/url.ts';
import type { VolunteerEventContent } from '../volunteer.ts';
export const VolunteerTourPage = t0 => {
  const $ = _c(34);
  const {
    location,
    tourLocations,
    content
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["skippy", "volunteers"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  let t2;
  if ($[1] !== t) {
    t2 = t("skippy:home", "Home");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = {
      title: t2,
      link: "/"
    };
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t("volunteers:breadcrumb.getInvolved");
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = slashes(getInvolvedUrlBase, "both");
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4) {
    t6 = {
      title: t4,
      link: t5
    };
    $[8] = t4;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t) {
    t7 = t("volunteers:breadcrumb.volunteer");
    $[10] = t;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = slashes(getVolunteerRolesPath(), "both");
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t7) {
    t9 = {
      title: t7,
      link: t8
    };
    $[13] = t7;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t) {
    t10 = t("volunteers:breadcrumb.tourInformation");
    $[15] = t;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== location.slug) {
    t11 = slashes(getVolunteerTourPath(location.slug), "both");
    $[17] = location.slug;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t10 || $[20] !== t11) {
    t12 = {
      title: t10,
      link: t11
    };
    $[19] = t10;
    $[20] = t11;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t12 || $[23] !== t3 || $[24] !== t6 || $[25] !== t9) {
    const breadcrumbs = [t3, t6, t9, t12];
    t13 = <Breadcrumb breadcrumbs={breadcrumbs} />;
    $[22] = t12;
    $[23] = t3;
    $[24] = t6;
    $[25] = t9;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== content || $[28] !== location || $[29] !== tourLocations) {
    t14 = <main id="main"><VolunteerTourTemplate location={location} tourLocations={tourLocations} content={content} /></main>;
    $[27] = content;
    $[28] = location;
    $[29] = tourLocations;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== t13 || $[32] !== t14) {
    t15 = <>{t13}{t14}</>;
    $[31] = t13;
    $[32] = t14;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  return t15;
};